import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={27}
    fill="none"
    {...props}
  >
    <path
      fill="#00E6BD"
      d="M17.62 26.283H4.334A3.351 3.351 0 0 1 .98 22.929V4.09C.98 2.236 2.48.736 4.335.736h13.284c1.855 0 3.355 1.5 3.355 3.355v18.838c0 1.855-1.5 3.354-3.355 3.354Z"
    />
    <path
      fill="#FF6E58"
      d="m27.905 14.743-1.977 1.144-1.755 1.01-8.253 4.766c-.9.522-2.022-.134-2.022-1.167V6.656c0-1.032 1.122-1.677 2.022-1.166l8.253 4.765 1.755 1.011 1.977 1.144c.9.522.9 1.81 0 2.333Z"
    />
  </svg>
)
export default SvgComponent
